import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { EditForm } from '../../../../base/controlers/edit-form';
import { ToastrService } from 'ngx-toastr';
import { Location } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { AccountInfo } from '../../models/account-info';
import { AccountInfoService } from '../../services/account-info.service';
import { ScheduleService } from '../../../../modules/time-tracking/services/schedule.service';
import { ScheduleType } from '../../../../modules/time-tracking/models/schedule-type';
import { AfterNew } from '../../../../interfaces/iedit-form';
import { IFileInfo } from '../../../../directives/file-drop/interfaces/IFileInfo';

@Component({
  selector: 'app-account-edit',
  templateUrl: './account-edit.component.html',
  styleUrls: ['./account-edit.component.css']
})
export class AccountEditComponent extends EditForm<AccountInfo> implements OnInit, AfterNew<AccountInfo> {
  scheduleTypes: ScheduleType[];
  constructor(
    ns: ToastrService,
    tr: TranslateService,
    r: Router,
    ds: AccountInfoService,
    ar: ActivatedRoute,
    l: Location,
    private schedduleTypeService: ScheduleService
  ) {
    super(ns, tr, r, ds, ar, l, '/administration/accounts');
  }

  ngOnInit() {
    this.form = new FormGroup({
      id: new FormControl(null),
      name: new FormControl(null),
      logoId: new FormControl(null),
      accountSettingsId: new FormControl(null),
      accountSettings: new FormGroup({
        id: new FormControl(null),
        accountInfoId: new FormControl(null),
        scheduleTypeId: new FormControl(null)
      })
    });
    super.ngOnInit();
    this.schedduleTypeService.GetCached().subscribe((result) => {
      this.scheduleTypes = result;
    });
  }
  onAterNew(model: AccountInfo): AccountInfo {

    return model;
  }
  onOnLogoUpload(logo: IFileInfo) {
    this.form.controls['logoId'].setValue(logo ? logo.id : null);
  }
}
